import React from "react";
import { render } from "react-dom";
import App from "./../app";

// Suppress wallet extension errors
const originalError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('Cannot redefine property: ethereum')) {
    return; // Silently ignore this specific error
  }
  originalError.apply(console, args);
};

document.addEventListener("DOMContentLoaded", () => {
  render(<App />, document.body.appendChild(document.createElement("div")));
});